import { Upload, Download, FileUp } from "lucide-react";
import { useCsvImport } from "../hooks/useCsvImport";
import { parseCsvRows, downloadCsvTemplate } from "../lib/csvImport";
import { FormDialog, Field, ActionButton } from "./common";

const HEADER_MAP = {
  name: "name",
  item: "name",
  product: "name",
  service: "name",
  type: "type",
  rate: "rate",
  price: "rate",
  description: "description",
  unitofmeasure: "unit_of_measure",
  unit_of_measure: "unit_of_measure",
  unit: "unit_of_measure",
  uom: "unit_of_measure",
  resourcetypes: "resource_types",
  resource_types: "resource_types",
  customerid: "customer_id",
  customer_id: "customer_id",
};

const TEMPLATE = "Name,Type,Rate,UnitOfMeasure,ResourceTypes,Description,CustomerID\nShop Labor - General,Service (Hourly labour),125,Hour,,General shop labor,\n";

const parseItems = (raw) => parseCsvRows(raw, HEADER_MAP, "name");

export const ProductServiceImport = ({ open, onOpenChange, onDone }) => {
  const { rows, parseErrors, csvText, busy, fileRef, reset, onFile, onPaste, submit } = useCsvImport({
    parse: parseItems, endpoint: "/product-service-items/import", entity: "items", onOpenChange, onDone,
  });
  const downloadTemplate = () => downloadCsvTemplate(TEMPLATE, "product_service_import_template.csv");

  return (
    <FormDialog open={open} onOpenChange={(v) => { onOpenChange(v); if (!v) reset(); }} title="Import Product & Service Items" testId="product-service-import-dialog">
      <div className="flex items-center justify-between">
        <p className="text-xs text-slate-400 leading-relaxed max-w-[320px]">
          CSV columns: <span className="font-mono text-amber-400/90">Name, Type, Rate, UnitOfMeasure, ResourceTypes, Description, CustomerID</span>
        </p>
        <button type="button" data-testid="product-service-template-download" onClick={downloadTemplate} className="inline-flex items-center gap-1.5 text-xs font-mono uppercase tracking-wider text-sky-400 hover:text-sky-300 transition-colors duration-200">
          <Download size={13} /> Template
        </button>
      </div>

      <Field label="Upload CSV file">
        <label data-testid="product-service-import-drop" className="flex items-center justify-center gap-2 border border-dashed border-slate-600 rounded-md px-4 py-5 text-sm text-slate-400 hover:border-amber-500/50 hover:text-amber-300 cursor-pointer transition-colors duration-200">
          <FileUp size={16} /> Choose .csv file
          <input ref={fileRef} data-testid="product-service-import-file" type="file" accept=".csv,text/csv" onChange={onFile} className="hidden" />
        </label>
      </Field>

      <Field label="…or paste CSV text">
        <textarea data-testid="product-service-import-textarea" value={csvText} onChange={(e) => onPaste(e.target.value)} rows={5} className="w-full rounded-md bg-slate-900 border border-slate-700 px-3 py-2 text-sm text-slate-100 font-mono focus:border-amber-500/60 focus:outline-none" placeholder="Name,Type,Rate,UnitOfMeasure,ResourceTypes,Description,CustomerID" />
      </Field>

      {parseErrors.length > 0 && <p className="text-xs text-rose-400" data-testid="product-service-import-errors">{parseErrors.length} row(s) could not be read. Check required column: Name.</p>}
      {rows.length > 0 && <p className="text-xs text-emerald-400" data-testid="product-service-import-count">{rows.length} item(s) ready to import.</p>}

      <ActionButton testId="product-service-import-submit" onClick={submit} disabled={busy || rows.length === 0} className="w-full justify-center">
        <Upload size={16} /> {busy ? "Importing…" : `Import ${rows.length || ""} Items`}
      </ActionButton>
    </FormDialog>
  );
};
